import { MimesHelper } from "./mimes-helper";

export function ensureImageDataUrl(base64: string, mimeType: string = 'image/png'): string {
    if (MimesHelper.isSimpleDataUrl(base64)) {
        return base64;
    }
    return `data:${mimeType};base64,${base64}`;
}

export function rotateIfLandscape(base64: string): Promise<string> {
    const dataUrl = ensureImageDataUrl(base64);
    return new Promise((resolve, reject) => {
        try {
            const img = new Image();
            img.src = dataUrl;
            img.onload = () => {
                if (img.width <= img.height) return resolve(dataUrl);

                const canvas = document.createElement('canvas');

                canvas.width = img.height;
                canvas.height = img.width > 1218 ? 1200 : img.width;

                const ctx = canvas.getContext('2d');
                if (!ctx) return reject('No canvas context');
                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate(90 * Math.PI / 180);
                ctx.drawImage(img, -canvas.height / 2, -canvas.width / 2);

                resolve(canvas.toDataURL());
            };

            img.onerror = () => {
                reject(new Error('Image failed to load. Check if the Base64 string is valid and starts with "data:image/".'));
            };
        } catch (err) {
            console.log('err', err);
        }
    });
};